import { Injectable, EventEmitter } from '@angular/core';
import { SignalRService, SignalREventService, Device, DataArray } from './../index';
//import { isNullOrUndefined } from "util";

@Injectable()
export class DeviceService {
    public devicesChange: EventEmitter<Device[]> = new EventEmitter<Device[]>();

    public devices: DataArray<Device> = new DataArray<Device>();

    public ascending = true;
    public orderBy = 'UserName';
    public currentPage = 1;
    public totalDevices = 0;

    public name = '';

    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService
    ) {
        this.registerOnServerEvents();
    }

    public getDevices(): void {
        //this.currentPage = page;
        this._signalRService.invoke('GetDevices', this.orderBy, this.ascending);
    }

    private onDevices(info: any): void {
        this.totalDevices = info.Data.Total;

        this.devices.init();

        for (const item of info.Data.Devices) {
            const device: Device = $.extend(new Device(), item);
            this.devices.push(device);
        }

        this.devicesChange.emit(this.devices.Data);
    }

    private registerOnServerEvents() {
        this._signalREventService.register('DeviceService', 'devices', (info: any) => this.onDevices(info));
    }


    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('DeviceService');
    }

    public applyFilter(name: string): void {
        this.name = name;
        if (this.name) {
            this._signalRService.invoke('FilterDevices', this.orderBy, this.ascending, this.name);
        } else {
            this._signalRService.invoke('GetDevices', this.orderBy, this.ascending);
        }
    }

}
